<template>
    <v-form ref="formRef">
        <v-row dense>
            <v-col cols="12" sm="6">
                <v-text-field :model-value="modelValue.numero" label="Numero commessa" :rules="[obbligatorio]"
                    @update:model-value="aggiorna({ numero: $event })" />
            </v-col>
            <v-col cols="12" sm="6">
                <v-text-field :model-value="modelValue.data" label="Data" type="date"
                    @update:model-value="aggiorna({ data: $event })" />
            </v-col>
            <v-col cols="12" sm="6">
                <v-text-field :model-value="modelValue.cliente" label="Cliente" :rules="[obbligatorio]"
                    @update:model-value="aggiorna({ cliente: $event })" />
            </v-col>
            <v-col cols="12" sm="6">
                <v-text-field :model-value="modelValue.lotto" label="Lotto"
                    @update:model-value="aggiorna({ lotto: $event })" />
            </v-col>
        </v-row>

        <div class="text-caption text-medium-emphasis font-weight-medium mt-2 mb-1">Dati cliente</div>
        <v-row dense>
            <v-col cols="12" sm="6">
                <v-text-field :model-value="modelValue.clienteIndirizzo" label="Indirizzo"
                    @update:model-value="aggiorna({ clienteIndirizzo: $event })" />
            </v-col>
            <v-col cols="4" sm="2">
                <v-text-field :model-value="modelValue.clienteCap" label="Cap"
                    @update:model-value="aggiorna({ clienteCap: $event })" />
            </v-col>
            <v-col cols="5" sm="3">
                <v-text-field :model-value="modelValue.clienteCitta" label="Città"
                    @update:model-value="aggiorna({ clienteCitta: $event })" />
            </v-col>
            <v-col cols="3" sm="1">
                <v-text-field :model-value="modelValue.clienteProv" label="Prov."
                    @update:model-value="aggiorna({ clienteProv: $event })" />
            </v-col>
        </v-row>

        <div class="text-caption text-medium-emphasis font-weight-medium mt-2 mb-1">Cantiere</div>
        <v-row dense>
            <v-col cols="12" sm="6">
                <v-text-field :model-value="modelValue.cantiere" label="Cantiere"
                    @update:model-value="aggiorna({ cantiere: $event })" />
            </v-col>
            <v-col cols="12" sm="6">
                <v-text-field :model-value="modelValue.cantiereIndirizzo" label="Indirizzo cantiere"
                    @update:model-value="aggiorna({ cantiereIndirizzo: $event })" />
            </v-col>
            <v-col cols="4" sm="2">
                <v-select :model-value="modelValue.cantiereProv" :items="province" item-title="sigla"
                    item-value="sigla" label="Prov." clearable @update:model-value="cambiaProvincia" />
            </v-col>
            <v-col cols="8" sm="6">
                <v-autocomplete :model-value="modelValue.cantiereComuneId" :items="comuni" item-title="nome"
                    item-value="id" label="Comune" clearable :disabled="!modelValue.cantiereProv"
                    @update:model-value="cambiaComune" />
            </v-col>
            <v-col cols="12" sm="4">
                <v-text-field :model-value="modelValue.cantiereCap" label="Cap cantiere"
                    @update:model-value="aggiorna({ cantiereCap: $event })" />
            </v-col>
        </v-row>
        <div v-if="comuneSelezionato" class="text-caption text-medium-emphasis">
            Zona climatica: <strong>{{ comuneSelezionato.zona || '—' }}</strong> — Gradi giorno:
            <strong>{{ comuneSelezionato.grg ?? '—' }}</strong>
        </div>
    </v-form>
</template>

<script>
import { anagrafica_lista } from "@/api/api.anagrafiche.js";

// Campi della commessa (testata, cliente, cantiere) condivisi tra creazione e modifica.
// Il genitore possiede l'oggetto: qui si emette sempre una copia aggiornata (v-model).
export default {
    name: "CommessaForm",

    props: {
        modelValue: { type: Object, required: true },
    },
    emits: ["update:modelValue"],

    data() {
        return {
            province: [],
            comuni: [],
        };
    },

    computed: {
        comuneSelezionato() {
            return this.comuni.find((c) => c.id === this.modelValue.cantiereComuneId) || null;
        },
    },

    watch: {
        // Ricarica i comuni quando cambia la provincia (anche all'apertura del dialog in modifica).
        "modelValue.cantiereProv": {
            immediate: true,
            handler(sigla) {
                this.caricaComuni(sigla);
            },
        },
    },

    async mounted() {
        try {
            const resp = await anagrafica_lista("province");
            this.province = resp.data;
        } catch (error) {
            console.log(error);
        }
    },

    methods: {
        obbligatorio(v) {
            return !!v || "Obbligatorio";
        },

        aggiorna(patch) {
            this.$emit("update:modelValue", { ...this.modelValue, ...patch });
        },

        async caricaComuni(sigla) {
            if (!sigla) {
                this.comuni = [];
                return;
            }
            try {
                const resp = await anagrafica_lista("comuni", { provincia: sigla });
                this.comuni = resp.data;
            } catch (error) {
                console.log(error);
            }
        },

        cambiaProvincia(sigla) {
            this.aggiorna({ cantiereProv: sigla || "", cantiereComuneId: null, cantiereCitta: "" });
        },

        cambiaComune(id) {
            const comune = this.comuni.find((c) => c.id === id);
            this.aggiorna({
                cantiereComuneId: id || null,
                cantiereCitta: comune ? comune.nome : "",
                cantiereCap: comune && !this.modelValue.cantiereCap ? comune.cap || "" : this.modelValue.cantiereCap,
            });
        },

        async validate() {
            const { valid } = await this.$refs.formRef.validate();
            return valid;
        },
    },
};
</script>
